import { render, staticRenderFns } from "./ManageDiscountCodeModal.vue?vue&type=template&id=20f9c91a&scoped=true&"
import script from "./ManageDiscountCodeModal.vue?vue&type=script&lang=js&"
export * from "./ManageDiscountCodeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f9c91a",
  null
  
)

export default component.exports